var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"pa-5"},[_c('v-col',{staticClass:"pr-md-6 pr-lg-12",attrs:{"cols":"12","md":_vm.isEven ? '6' : '5',"lg":"6"}},[_vm._t("left")],2),_c('v-col',{staticClass:"pl-md-6 pl-lg-12",attrs:{"cols":"12","md":_vm.isEven ? '6' : '7',"lg":"6"}},[_vm._t("right")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }